module.exports = __webpack_public_path__ + "img/hand-holding-box.588ccd69.svg";